<template>


    <div>
        <form id="cnfmForm" name="cnfmForm" method="get" action="/after-activation">
        </form>

        <v-dialog/>
    </div>
</template>

<script>
    import { getAfterActivationDetailDecrypt } from '@/api/common'

    export default {
        name: "afterActivationAuthResult",

        data() {
            return {
                r_certNum:'',
                r_date:'',
                r_phoneNo:'',
                r_phoneCorp:'',
                r_birthDay:'',
                r_gender:'',
                r_nation:'',
                r_name:'',
                r_result:'',
                r_resultCode:'',
                r_check_1:'',
                r_check_2:'',
                r_check_3:'',
            }
        },

        mounted() {
            this.getInfo();
        },

        methods: {
            getInfo() {
                let rec_cert = this.$route.query.rec_cert
                let certNum = this.$route.query.certNum


                if(rec_cert === "" || certNum === ""){
                    this.$modal.show('dialog', {
                        title: '본인 인증 실패',
                        text: '본인 인증을 실패했습니다.',
                        buttons: [{
                            title: '확인'
                        }]
                    })
                    return;
                }
                getAfterActivationDetailDecrypt(rec_cert, certNum).then(res => {
                    this.r_certNum = res.data.r_certNum
                    this.r_date = res.data.r_date
                    this.r_phoneNo = res.data.r_phoneNo
                    this.r_phoneCorp = res.data.r_phoneCorp
                    this.r_birthDay = res.data.r_birthDay
                    this.r_gender = res.data.r_gender
                    this.r_nation = res.data.r_nation
                    this.r_name = res.data.r_name
                    this.r_result = res.data.r_result
                    this.r_resultCode = res.data.r_resultCode
                    this.r_check_1 = res.data.r_check_1
                    this.r_check_2 = res.data.r_check_2
                    this.r_check_3 = res.data.r_check_3

                    if (this.r_result === "Y" ) {
                        alert("본인인증이 성공하였습니다.");
                        let data = {
                            r_name: this.r_name,
                            r_phoneNo: this.r_phoneNo,
                            r_birthDay: this.r_birthDay,
                            r_certNum: this.r_certNum
                        }
                        this.$store.state.kmcInfo.name = this.r_name
                        this.$store.state.kmcInfo.phoneNo = this.r_phoneNo
                        this.$store.state.kmcInfo.birthDay = this.r_birthDay
                        this.$store.state.kmcInfo.certNum = this.r_certNum

                        let returnValue = {
                            name: this.r_name,
                            phoneNo: this.r_phoneNo,
                            birthDay: this.r_birthDay,
                            certNum: this.r_certNum
                        }
                        window.opener.cbAuthPop(JSON.stringify(returnValue))
                        window.close()

                    } else {
                        alert("인증처리중 오류가 발생했습니다[" + this.r_result  + "]");
                        window.close()
                    }
                })
            },
        },
    }
</script>

<style scoped>

</style>